"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { FlexAlignDirective as FlexLayoutFlexAlignDirective, MediaMonitor, } from '@angular/flex-layout';
var FlexAlignDirective = (function (_super) {
    __extends(FlexAlignDirective, _super);
    function FlexAlignDirective(monitor, elRef, renderer) {
        return _super.call(this, monitor, elRef, renderer) || this;
    }
    Object.defineProperty(FlexAlignDirective.prototype, "align", {
        set: function (val) {
            this._cacheInput('align', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlexAlignDirective.prototype, "alignMobile", {
        set: function (val) {
            this._cacheInput('alignMobile', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlexAlignDirective.prototype, "alignTablet", {
        set: function (val) {
            this._cacheInput('alignTablet', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlexAlignDirective.prototype, "alignDesktopSmall", {
        set: function (val) {
            this._cacheInput('alignDesktopSmall', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlexAlignDirective.prototype, "alignDesktopLarge", {
        set: function (val) {
            this._cacheInput('alignDesktopLarge', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlexAlignDirective.prototype, "alignDesktopXLarge", {
        set: function (val) {
            this._cacheInput('alignDesktopXLarge', val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlexAlignDirective.prototype, "alignDesktopXXLarge", {
        set: function (val) {
            this._cacheInput('alignDesktopXXLarge', val);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Input('flLayoutFlexAlign'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], FlexAlignDirective.prototype, "align", null);
    __decorate([
        Input('flLayoutFlexAlign.mobile'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], FlexAlignDirective.prototype, "alignMobile", null);
    __decorate([
        Input('flLayoutFlexAlign.tablet'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], FlexAlignDirective.prototype, "alignTablet", null);
    __decorate([
        Input('flLayoutFlexAlign.desktop-small'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], FlexAlignDirective.prototype, "alignDesktopSmall", null);
    __decorate([
        Input('flLayoutFlexAlign.desktop-large'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], FlexAlignDirective.prototype, "alignDesktopLarge", null);
    __decorate([
        Input('flLayoutFlexAlign.desktop-xlarge'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], FlexAlignDirective.prototype, "alignDesktopXLarge", null);
    __decorate([
        Input('flLayoutFlexAlign.desktop-xxlarge'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], FlexAlignDirective.prototype, "alignDesktopXXLarge", null);
    FlexAlignDirective = __decorate([
        Directive({
            selector: "\n    [flLayoutFlexAlign],\n    [flLayoutFlexAlign.mobile],\n    [flLayoutFlexAlign.tablet],\n    [flLayoutFlexAlign.desktop-small],\n    [flLayoutFlexAlign.desktop-large],\n    [flLayoutFlexAlign.desktop-xlarge],\n    [flLayoutFlexAlign.desktop-xxlarge],\n  ",
        }),
        __metadata("design:paramtypes", [MediaMonitor, ElementRef, Renderer2])
    ], FlexAlignDirective);
    return FlexAlignDirective;
}(FlexLayoutFlexAlignDirective));
export { FlexAlignDirective };



// WEBPACK FOOTER //
// flex-align.directive.js